export default function(): void {
  const btnDiv = document.createElement("div");
  btnDiv.innerHTML = `<call-us 
style="position: fixed; bottom: 8px; right: 8px; z-index: 99999;--call-us-form-header-background:#007bc7;--call-us-header-text-color:#ffffff;--call-us-form-height:470px;--call-us-form-width:250px;"
phonesystem-url="https://thatsvoip.3cx.nl:5001/"
party="chatportal"
allow-call="true"
allow-video="false"
authentication="both"
invite-message= "Hallo waar mee kan ik u helpen ?"
operator-name="Support"
operator-icon="http://b2bimage.nl/estos/b2bmale.png"
allow-soundnotifications="false"
enable-poweredby="false"
ignore-queueownership="false"
show-typing-indicator="false"
auto-focus="false"
enable-onmobile="true"
popout="true"
window-title="Neem contact met ons op"
window-icon="http://b2bimage.nl/estos/b2bchatbox.png"
show-operator-actual-name="false"
animation-style="none"
minimized="false"
minimized-style="bubble">
</call-us>`;

  const btn = btnDiv.childNodes.item(0);
  const script = document.createElement("script");
  script.setAttribute("src", "https://thatsvoip.3cx.nl:5001/callus.js");

  const body = document.getElementsByTagName("body")[0];

  body.appendChild(btn);
  body.appendChild(script);
}
